export default __webpack_public_path__ + "static/media/sqr_img_1.805cc7b6.svg";